export default "__VITE_ASSET__8a49b559__"